const apiUrl = window.location.hostname === 'localhost' || window.location.hostname?.split('.')[0] === 'kiosk-beta'
    ? 'http://136.144.211.151:7777'
    : 'http://localhost:7777';

export const lock = async () => {
    await fetch(`${apiUrl}/PayTerminalService/LockPayTerminal`);
};

export const isLocked = async () => {
    const response = await fetch(`${apiUrl}/PayTerminalService/IsLocked`);
    const status = await response.text();
    return status === 'true';
};

export const initPayEngine = async () => {
    await fetch(`${apiUrl}/PayEngineService/InitPayEngine`);
};

export const isInitialised = async () => {
    const response = await fetch(`${apiUrl}/PayEngineService/IsInitialized`);
    const status = await response.text();
    return status === 'true';
};

export const cancelDebitWithRefund = async () => {
    await fetch(`${apiUrl}/PayEngineService/CancelPaymentWithRefund`);
};

export const cancelDebitWithoutRefund = async () => {
    await fetch(`${apiUrl}/PayEngineService/CancelPayment`);
};

export const debit = async (amount) => {
    const normalizedAmount = Math.round(Number(amount));
    const response = await fetch(`${apiUrl}/PayEngineService/Debit?amount=${normalizedAmount}`);
    const text = await response.text();
    return text.replace(/^"|"$/g, '');
};

export const getPaymentState = async () => {
    const response = await fetch(`${apiUrl}/PayEngineService/GetCurrentPaymentState`);
    const status = await response.text();
    return parseInt(status);
};

export const getPayment = async (id) => {
    const response = await fetch(`${apiUrl}/PayEngineService/GetPaymentTransaction?paymentTransactionID=${id}`);
    return await response.json();
};

export const initDeliveryService = async () => {
    const response = await fetch(`${apiUrl}/DeliveryService/InitDeliveryService`);
    return response.status === 200;
}

export const configureDeliveryItem = async (data, template) => {
    await fetch(`${apiUrl}/DeliveryService/ConfigureDeliveryDevice`, {
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
            configItem: {
                m_Item1: "htmlFileTemplate",
                m_Item2: template
            },
            deliveryDevice: "Printer"
        }),
    });

    for (const [key, value] of Object.entries(data)) {
        await fetch(`${apiUrl}/DeliveryService/ConfigureDeliveryDevice`, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({
                configItem: {
                    m_Item1: key,
                    m_Item2: value
                },
                deliveryDevice: "Printer"
            }),
        });
    }

    return true;
};


export const deliverItem = async () => {
    const response = await fetch(`${apiUrl}/DeliveryService/DeliverItems?deliveryDevice=Printer&numItems=1`);
    const text = await response.text();
    return text.replace(/^\"|\"$/g, '');
}

export const delivered = async (id) => {
    const response = await fetch(`${apiUrl}/DeliveryService/GetDeliveryState?deliveryTransactionID=${id}`);
    return (await response.text()) === "1";
}
